"use strict";

var _taggedTemplateLiteral = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  from { transform: rotate(0); }\n  to { transform: rotate(1turn); }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.LoaderWrapper = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _core = require("@emotion/core");

var spin = (0, _core.keyframes)(_templateObject());
var LoaderWrapper = (0, _styled.default)('div')(function (_ref) {
  var size = _ref.size;
  return {
    animation: "".concat(spin, " 1s linear infinite"),
    width: "".concat(size, "px"),
    height: "".concat(size, "px"),
    padding: '8px'
  };
});
exports.LoaderWrapper = LoaderWrapper;
var _default = LoaderWrapper;
exports.default = _default;